import React from 'react';
import Chip from '../chip';
import { combineNames } from '../../utils';

// --Not a reusable component--
// -- Still Being used as reusable
const SelectType = ({ totalSelectedData, filterData, searchInput, onDeselectOption, searchData, onSelectOption }) => {
    return (
      <div className='select-open-container'>
        <div className='select-open-main'>
          {!!totalSelectedData.length &&
            filterData(totalSelectedData).map(chipData => (
              <Chip
                key={chipData?.id + '-black-head-data'}
                highlightText={searchInput}
                name={combineNames(chipData)}
                darkMode={true}
                onClickChip={() => onDeselectOption(chipData)}
                iconSrc={chipData.image || ''}
                iconErrorSrc={chipData?.iconErrorSrc}
              />
            ))}
  
          {!!searchData?.length &&
            filterData(searchData)
              .filter(searchFilterData =>
                totalSelectedData.length
                  ? !totalSelectedData
                    .map(selectedChipData => selectedChipData.id)
                    .includes(searchFilterData.id)
                  : true
              )
              .map(chipData => (
                <Chip
                  key={chipData?.id}
                  highlightText={searchInput}
                  name={combineNames(chipData)}
                  onClickChip={() => onSelectOption(chipData)}
                  iconSrc={chipData.image || ''}
                  iconErrorSrc={chipData?.iconErrorSrc}
                />
              ))}
        </div>
      </div>
    )
  }

  export default SelectType